<template>
  <unauthorized-access v-if="!isAuthorized">
    You are signed in as {{ currentUser.email }}.
  </unauthorized-access>
  <div
    v-else
    class="row"
  >
    <div class="col">
      <h3>Categories</h3>

      <div class="d-grid gap2 mb-2">
        <Alert
          :message="success"
          status="success"
          @alert-displayed="resetSuccess"
        />
        <button
          class="btn btn-secondary"
          @click="newCategory"
        >
          Create New Category
        </button>
      </div>
      <div v-if="categories">
        <ul class="list-group">
          <li
            v-for="cat in categories"
            :key="cat.id"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-start"
            @click="edit(cat)"
          >
            <div class="ms-2 me-auto">
              <template v-if="cat.parent_id">
                <span
                  v-if="getParent(cat.parent_id)"
                  class="mark small"
                >
                  {{ getParent(cat.parent_id) }}
                </span>
                <span
                  v-else
                  class="badge text-bg-warning"
                >
                  Missing Parent ID: {{ cat.parent_id }}
                </span>
              </template>
              <span class="ms-2">
                {{ cat.name }}
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div v-else>
        <h4> Loading</h4>
        <Alert
          status="danger"
          :message="errorMessage"
        />
      </div>
    </div>
    <Edit
      v-bind="{...selectedCategory}"
      ref="modal"
      :categories="categoriesForSelect"
      @wts:category-saved="updateCategory"
    />
  </div>
</template>

<script>
import { trackError } from '@/helpers/google-analytics-tracker';
import AdminAuthorizationCheck from '@/services/admin/authorization-check';
import CategoryService from '@/services/admin/category.service.js';
import Alert from '@/components/admin/Alert.vue';
import Edit from './Edit';
import UnauthorizedAccess from '../UnauthorizedAccess.vue';

export default {
  name: 'Category',
  components: {
    Alert,
    Edit,
    UnauthorizedAccess
  },
  setup() {
    return {
      ...AdminAuthorizationCheck()
    };
  },
  data() {
    return {
      categories: [],
      errorMessage: null,
      selectedCategory: null,
      success: "",
    }
  },
  computed: {
    categoriesForSelect() {
      const selectedCategoryId = this.selectedCategory?.id;
      return this.categories.filter((cat) => cat.id !== selectedCategoryId)
    },
  },
  async mounted() {
    try {
      const categories = await this.fetchCategories();
      if (!categories.empty) {
        this.categories = categories
      }
    }
    catch(e) {
      trackError(e);
    }
  },
  methods: {
    async fetchCategories() {
      this.errorMessage = null;
      try {
        const resp = await CategoryService.fetchAll();
        this.categories = resp.data;
        return this.categories;
      }
      catch (error) {
        this.errorMessage = error.message;
        console.log('Error: ', error.message);
        trackError(error);
      }
    },
    updateCategory(category) {
      this.success = "Successfully Updated!"
      const index = this.categories.findIndex((cat) => cat.id == category.id)
      if (index) {
        this.categories[index] = category
      }
      else {
        this.categories.push(category);
      }
    },
    resetSuccess() {
      setTimeout(() => { this.success = "" }, 5000);
    },
    getParent(parentId) {
      const category = this.categories.find((cat) => cat.id === parentId)
      return `${category.name} \u00bb`
    },
    edit(category) {
      const { id, name: initialName, parent_id: initialParentId } = category;
      this.selectedCategory = { id, initialName, initialParentId };
      this.$refs.modal.show()
    },
    newCategory() {
      this.selectedCategory = { id: null, initialName: null, initialParentId: null };
      this.$refs.modal.show()
    },
  },
}
</script>
